// src/components/WorkTypeTags.js — a mandate's engaged work (from its EL) as
// labels: "Financial Advisory › Direct Capital Raising & Placement". Kept
// apart from the investment taxonomy tags. Shared by the CRM and the portal.
import { workTypeChains, workTypeLabel, useIsPortal } from '../lib/workTypes'

// compact: tiles and cards. Sub-types only, since tiles sit under a work
// type heading; nothing when there are no sub-types. Full view (mandate
// pages) shows the whole chain.
export default function WorkTypeTags({ workType, workSubtype, compact = false, style }) {
  const partner = useIsPortal()
  const chains = workTypeChains(workType, workSubtype).filter(c => !compact || c.subtypes.length)
  if (!chains.length) return null
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, ...style }}>
      {chains.map(c => {
        const type = workTypeLabel(c.type, partner)
        const full = c.subtypes.length ? `${type} › ${c.subtypes.join(', ')}` : type
        return (
          <span key={c.type} className="badge badge-gray"
            style={{ fontSize: compact ? 11 : 12, whiteSpace: 'normal', textAlign: 'left', lineHeight: 1.35,
              border: '1px solid var(--border-light)' }}
            title={`Work type: ${full}`}>
            {compact && c.subtypes.length ? c.subtypes.join(', ') : full}
          </span>
        )
      })}
    </div>
  )
}
